module.exports = __webpack_public_path__ + "media/images/pls_meeting_tracking-158680fa12460d4c2dcb1630a9263af5.png";